import {combine} from 'effector';
import {createGate} from 'effector-react/effector-react.cjs';

import {fetchTracingDetail, fetchTracingGraph} from 'api';
import {RestError} from 'core/errors';
import {rootDomain} from 'core/rootDomain';
import {TracingDetailRaw, TracingNode} from 'types';
import {getFirstDayOfMonth, getLastDayOfMonth} from 'utils/date';

const domain = rootDomain.createDomain('TracingDetailDomain');
export const Gate = createGate<{id: string; gtin: string}>('TracingDetailGate');

export const fetchTracingDetailFx = domain.createEffect({
    name: 'fetchDataFx',
    handler: fetchTracingDetail,
});

export const fetchTracingGraphFx = domain.createEffect({
    name: 'fetchGraphDataFx',
    handler: fetchTracingGraph,
});

export const data$ = domain.createStore<TracingDetailRaw | null>(null);
export const periodChanged = domain.createEvent<[Date | null, Date | null]>();
export const period$ = domain.createStore<[Date | null, Date | null]>([
    getFirstDayOfMonth(),
    getLastDayOfMonth(),
]);
export const graph$ = domain.createStore<TracingNode | null>(null);
export const error$ = domain.createStore<RestError | null>(null);

export const dataState$ = combine({
    data: data$,
    graph: graph$,
    period: period$,
    error: error$,
    isLoading: fetchTracingDetailFx.pending,
    isLoadingGraph: fetchTracingGraphFx.pending,
});
